import { useState } from "react";
import { api } from "../../../../service/api";

export function useDeleteAcquisitionStock() {
  const [loadingDelete, setLoadingDelete] = useState(false);

  const deleteStock = async (id: string) => {
    try {
      setLoadingDelete(true);
      await api.delete("company/stock/acquisition/delete/" + id);
    } catch (error) {
      throw error;
    } finally {
      setLoadingDelete(false);
    }
  };

  return { loadingDelete, deleteStock };
}
